import { AutogenLayoutCustomerResets } from "./autogen/AutogenLayoutCustomerResets";
import { CompanySettings } from "@mcleod/core";

// Other reset type descriptions can be added here in the future
export enum ResetTypeDescription {
    RESET_BALANCES = "Reset Customer Balances"
}

export interface CustomerResetLayoutProps {
    processLogEnabled: boolean;
    setActionButtonsBusy?: (isBusy: boolean) => void;
}

export class CustomerResets extends AutogenLayoutCustomerResets {
    public processLogEnabled: boolean = false;

    override onLoad() {
        this.processLogEnabled = CompanySettings.getSingleton().isProcessLogEnabled();
        this.layoutResetCustomerBalances.initialize(this.getResetCustomerBalancesProps());
    }

    getResetCustomerBalancesProps(): CustomerResetLayoutProps {
        return {
            processLogEnabled: this.processLogEnabled,
            setActionButtonsBusy: this.setActionButtonsBusy.bind(this)
        }
    }

    // Other actions can be added here in the future
    setActionButtonsBusy(isBusy: boolean) {
        this.layoutResetCustomerBalances.buttonRunReset.busy = isBusy;
    }
}
